/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Threewayvalve2Inputs */



/**
* | output |
* | --- |
* | "3-way valve" |
*
* @param {Ahu_History_Key_Threewayvalve2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_threewayvalve2 = /** @type {((inputs?: Ahu_History_Key_Threewayvalve2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Threewayvalve2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("3-way valve")
	return /** @type {LocalizedString} */ ("Vanne 3 voies")
});
export { ahu_history_key_threewayvalve2 as "ahu_history_key_threeWayValve" }